module.exports = __webpack_public_path__ + "static/media/house12.1502ef22.png";